<template>
  <v-card elevation="1" class="mb-4">
    <v-card-text>
      <h6 class="text-h6 black--text">Datos generales</h6>
      <p class="text-body-2">Ingrese los datos basicos de la operacion de inventario</p>
      <v-row class="mt-0">
        <v-col md="4" class="mt-2">
          <v-combobox
            :loading="loading_op_types"
            v-model="item.op_type"
            data-vv-as="tipo de operacion"
            name="op_type"
            item-text="name"
            item-value="id"
            :items="op_types"
            label="Tipo de operacion*"
            autocomplete="off"
            v-validate="'required'"
            :disabled="isViewModal || item.id > 0"
          ></v-combobox>
          <span class="red--text">{{ errors.first("op_type") }}</span>
        </v-col>

        <v-col md="4" class="mt-2">
          <v-combobox
            :loading="loading_document_types"
            v-model="item.document_type"
            data-vv-as="tipo de documento"
            name="document_type"
            item-text="name"
            item-value="id"
            :items="document_types"
            label="Tipo de documento*"
            autocomplete="off"
            v-validate="'required'"
            :disabled="isViewModal || item.op_type == null"
          ></v-combobox>
          <span class="red--text">{{ errors.first("document_type") }}</span>
        </v-col>

        <v-col md="4" class="mt-2">
          <v-combobox
            :loading="loading_stock_types"
            v-model="item.stock_type"
            data-vv-as="tipo de stock"
            name="stock_type"
            item-text="name"
            item-value="id"
            :items="stock_types"
            label="Tipo de stock*"
            autocomplete="off"
            v-validate="'required'"
            :disabled="isViewModal"
          ></v-combobox>
          <span class="red--text">{{ errors.first("stock_type") }}</span>
        </v-col>

        <v-col md="4">
          <v-text-field
              data-vv-as="Referencia externa"
              :disabled="isViewModal"
              autocomplete="off"
              name="external_reference"
              placeholder="Referencia externa*"
              dense
              v-model="item.external_reference"
            />
          <span class="red--text">{{ errors.first("external_reference") }}</span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import Constant from "@/constants/sections";
import { inventoryOperationService } from "@/libs/ws/inventoryOperationService";

export default {
  components: {  },
  props: { item: Object, isViewModal: Boolean, validator: Object },
  created() {
    this.$validator = this.validator;
  },
  data: () => ({
    document_types: [],
    op_types: [],
    stock_types: [],
    loading_op_types: false,
    loading_stock_types: false,
    loading_document_types: false,
  }),
  watch: {
    'item.op_type': function (newVal) {
      if (newVal) {
        this.getAllDocumentTypes();
      }
    },
    item: {
      handler: function (newValue) {
      
      },
      deep: true,
    },
  },
  mounted() {
    this.getOpTypes();
    // this.getAllDocumentTypes();
    this.getStockTypes();
  },
  methods: {
    getStockTypes() {
      this.loading_stock_types = true;

      inventoryOperationService
        .getStockTypes()
        .then((response) => {
          if (response.status) {
            this.stock_types = response.result;
          }
        })
        .catch((e) => {
          console.log("error get op types", e);

        })
        .finally(() => {
          this.loading_stock_types = false;
        })
    },
    getOpTypes() {
      this.loading_op_types = true;

      inventoryOperationService
        .getOpTypes()
        .then((response) => {
          if (response.status) {
            this.op_types = response.result;
          }
        })
        .catch((e) => {
          console.log("error get op types", e);

        })
        .finally(() => {
          this.loading_op_types = false;
        })
    },
    getAllDocumentTypes() {
      this.loading_document_types = true;
      const params = {
        op_type: this.item.op_type != null ? this.item.op_type.id : null,
      };

      inventoryOperationService
        .getAllDocumentTypes(params)
        .then((response) => {
          if (response.status) {
            this.document_types = response.result;
          }
        })
        .catch((e) => {
          console.log("error get op types", e);

        })
        .finally(() => {
          this.loading_document_types = false;
        })
    },
  },
};
</script>
